import {C} from "../../configurations/active-configuration";

/**
 * TODO: Introduce a customer_s_id field in the BE
 * @deprecated
 */
export function getSupplierIdHack(data: any): string {
    if (!data) return ''
    const s_customer_id_priority: string | undefined | null = data.s_customer_id || data.s_id
    if (C.profile.showSupplierIdPrefixCutoffHack !== undefined) {
        switch (C.profile.showSupplierIdPrefixCutoffHack.type) {
            case 'by_substring':
                return s_customer_id_priority?.substring(C.profile.showSupplierIdPrefixCutoffHack.start) || ''
            case 'by_split':
                return s_customer_id_priority?.split(C.profile.showSupplierIdPrefixCutoffHack.separator, 2)?.at(-1) || ''
        }
    }
    return s_customer_id_priority || '';
}

/**
 * TODO: Introduce a customer_bu_id field in the BE
 * @deprecated
 */
export function getBusinessUnitIdHack(data: any) {
    if (C.profile.showBuIdPrefixCutoffHack !== undefined) {
        return data.bu_id?.substring(C.profile.showBuIdPrefixCutoffHack)
        // .replace('_', ' ')
    }
    return data.bu_id;
}
